import { Router, ActivatedRoute } from '@angular/router';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Usuario } from '../shared/model/security/usuario.model'
import { Menu } from '../shared/model/security/menu.model';
import { SweetAlertComponent } from '../shared/SweetMesssage';
import { MensajesFijosEnum } from '../utilerias/enums/mensajes-fijos-enum';

import { UrlConstantes } from '../utilerias/constantes/urlconstantes';
import { ConsultaList } from '../shared/model/core/ConsultaList.model';
import { ConfiguracionGeneral } from '../shared/model/catalogos/configuracionGeneral.model';


@Injectable({
  providedIn: 'root'
})
export class AuthService {
  user: Usuario;
  menus: Menu[];

  constructor(
    private router: Router,
    private http: HttpClient,
    private mensaje: SweetAlertComponent
  ) { }

  crearAuthToken() {
    const token = localStorage.getItem('tkCocred');
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'X-Auth-Token': token,
    });
  }

  createBasicAuthToken(username: string, password: string) {
    return 'Basic ' + window.btoa(username + ':' + btoa(password));
  }

  loginUser(usuario: string, password: string) {

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      authorization: this.createBasicAuthToken(usuario, password)
    })

    this.user = new Usuario(usuario, btoa(password));


    this.http.post<any>(UrlConstantes.login, this.user, { headers: headers, responseType: 'json', observe: 'response' }).subscribe((resp) => {

      const message = resp.body;

      if (message === null || message === undefined) {
        this.mensaje.show('error-message', MensajesFijosEnum.ERROR_SERVIDOR);
        return
      } else if (message !== null && message !== undefined && message.mensaje != null) {
        this.mensaje.show('error-message', message.mensaje);

      } else if (resp !== null && resp !== undefined && resp.headers !== undefined && resp.headers !== null) {
        localStorage.setItem('tkCocred', resp.headers?.get('X-Auth-Token') ?? '');
        localStorage.setItem('user', JSON.stringify(message));
        localStorage.setItem('inactividad', JSON.stringify(message.inactividad));
        localStorage.setItem('tiempoMensaje', JSON.stringify(message.mensajeIn));
        if ((localStorage.getItem('tkCocred') != null)) {
          localStorage.setItem('pEstatus', 'ACTIVO');
        } else {
          localStorage.setItem('pEstatus', '');
        }

        this.obtenerConfiguracion("MAX_CREDITO")
        this.obtenerConfiguracion("MIN_CREDITO")
        this.obtenerConfiguracion("UMAS")

        this.obtenerConfiguracion("UMACOSTO")
        this.obtenerConfiguracion("DIAS_ANIOINTERES")
        this.obtenerConfiguracion("VAL_IVA")

        this.obtenerConfiguracion("FLUJO")

        this.obtenerConfiguracion("MAX_ANIO_NACIMIENTO")
        this.obtenerConfiguracion("MIN_ANIO_NACIMIENTO")

        this.getMenus();
      }
    }, () => {
      this.mensaje.show('error-message', MensajesFijosEnum.ERROR_SERVIDOR);
    });
  }

  private obtenerConfiguracion(configuracion: string) {
    const confGral: ConfiguracionGeneral = new ConfiguracionGeneral();
    confGral.conf_fol_pr = configuracion;
    this.http.post<ConsultaList<ConfiguracionGeneral>>(UrlConstantes.BUSCAGEN_CONFIG, confGral, { headers: this.crearAuthToken(), responseType: 'json', observe: 'response' }).subscribe(res => {
      if (res.status === 200) {
        localStorage.setItem(configuracion, JSON.stringify(res?.body?.list[0].valor1));
      } else this.mensaje.show("error-message", "No se encontró el mínimo de crédito");
    });
  }

  logout() {
    this.http.get(UrlConstantes.cerrarSession, { headers: this.crearAuthToken() })
      .subscribe(
        (resp) => {
          localStorage.clear()
          window.location.reload();
        }
      );

    localStorage.clear()
    window.location.reload();
  }

  getToken() {
    return localStorage.getItem('tkCocred');
  }

  isAuthenticated() {
    return localStorage.getItem('tkCocred') != null;
  }

  isUserSessionValid(): boolean {
    return (localStorage.getItem('pEstatus') != null && localStorage.getItem('pEstatus') === 'ACTIVO');
  }


  isActivated() {
    return (localStorage.getItem('pEstatus') != null && localStorage.getItem('pEstatus') === 'SOLICITUD');
  }

  getMenus() {

    this.http.get<Menu[]>(UrlConstantes.getMenu, { headers: this.crearAuthToken() }).subscribe((menus: Menu[]) => {
      menus.forEach(menu => {
        if (menu.subMenu && menu.subMenu.length > 0) {
          menu.subMenu = menu.subMenu.filter(submenu => submenu.nombre != "Verificador de Personas");
        }
      });

      localStorage.setItem('menuItems', JSON.stringify(menus));
      this.menus = this.getMenuList();
      this.router.navigate(['./dashboard']);
    });
  }

  getMenuList(): Menu[] {
    const retrievedObject = localStorage.getItem('menuItems');
    return retrievedObject ? JSON.parse(retrievedObject) : [];
  }

  validateSesion() {
    return this.http.post<any>(UrlConstantes.validaSession, '',{ headers: this.crearAuthToken() });
  }

}
